import { render } from "./View.vue?vue&type=template&id=c34eac1e&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"

import "./View.vue?vue&type=style&index=0&id=c34eac1e&scoped=true&lang=css"
import "@vueform/toggle/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c34eac1e"]])

export default __exports__